import React from 'react';
import styled from 'styled-components';
import { Toolbar, ToolbarProps } from '@material-ui/core';
import { ToolbarPaper } from './style';

const SecondaryToolbar = styled(
    ({ ...other }: Omit<ToolbarProps, 'component' | 'zindex'>) => (
        <Toolbar component={ToolbarPaper} zindex={1} {...other} />
    )
)``;


export default SecondaryToolbar;
